import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { environment } from '../../../environments/environment';
import { catchError, firstValueFrom, map, throwError } from 'rxjs';
import { Voucher } from '../../interfaces/voucher';
import { ApplyVoucher } from '../../interfaces/apply-voucher';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

    protected apiVersion = environment.apiVersion;
    protected apiURL = environment.apiUrl;

    constructor(protected httpClient: HttpClient, private localStorageService: LocalStorageService) {
        this.apiURL = this.apiURL + '/v' + this.apiVersion;
    }

    async applyVoucher(voucher: ApplyVoucher): Promise<any> {
        const response = await firstValueFrom(this.httpClient
        .post<any>(`${this.apiURL}/Voucher/apply-voucher`, voucher)
        .pipe(
            map(response => response.data[0]),
            catchError(this.handleError)
        ));

        return response;
    }

    private handleError(error: HttpErrorResponse) {
      let errorMessage = 'Erro inesperado. Tente novamente.';
  
      if (error?.error?.notifications?.length) {
        errorMessage = error.error.notifications[0].message;
      }
  
      console.error('HTTP Error:', error);
  
      return throwError(() => new Error(errorMessage));
    }
}
